import { render } from "./YushouTable.vue?vue&type=template&id=d72765b6&scoped=true"
import script from "./YushouTable.vue?vue&type=script&lang=js"
export * from "./YushouTable.vue?vue&type=script&lang=js"

import "./YushouTable.vue?vue&type=style&index=0&id=d72765b6&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72765b6"]])

export default __exports__